// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const modalStyles = css`
  div.TCPModal__InnerContent.atb-innerContent {
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    padding: 7px 0 0 17px;
    width: 350px;
    overflow-x: hidden;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 375px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 481px;
      animation: slide-in 0.5s forwards;
      overflow-y: ${(props) => (props.isSafari ? 'scroll' : 'overlay')};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
      animation: slide-in-mobile 0.5s forwards;
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
        ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0px 0px;
      padding: 7px 0 0;
      height: 96%;
    }

    &.hide-qv-content {
      display: none !important;
    }

    @keyframes slide-in {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0%);
      }
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }
    @keyframes slide-out {
      0% {
        transform: translateX(0%);
      }
      100% {
        transform: translateX(100%);
      }
    }

    .close-modal {
      right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
      top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      @media ${(props) => props.theme.mediaQuery.medium} {
        top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
      }
    }
    .blurred-content {
      filter: blur(4px);
      -o-filter: blur(4px);
      -ms-filter: blur(4px);
      -moz-filter: blur(4px);
      -webkit-filter: blur(4px);
    }
    .Modal-Header {
      top: 0;
      position: sticky;
      z-index: 100;
      min-height: 53px;
    }
    .modal-heading {
      border-bottom: none;
      padding-bottom: 26px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      justify-content: center;
      height: auto;
      display: block;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 60%;
      text-align: center;
      margin: 0 auto;

      @media ${(props) => props.theme.mediaQuery.medium} {
        justify-content: center;
        height: auto;
        padding-top: 5px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        padding-top: 9px;
        text-align: center;
      }
    }
    .modal-heading:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 51px;
      margin: auto;
      z-index: -1;
      background-color: #f4f4f4;
      bottom: 10px;
      left: -17px;
      padding-right: 17px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        left: -17px;
        padding-right: 17px;
      }
    }
  }
  div.TCPModal__InnerContent.multi-atb-drawer-modal {
    padding-right: 14px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-right: 5px;
    }
    .modal-heading {
      text-align: center;
    }

    .CheckBox__input:before {
      background: ${(props) => props.theme.colors.GAINSBORO};
      border: 1px solid ${(props) => props.theme.colors.GAINSBORO};
      border-radius: 50%;
    }
    .CheckBox__input:checked:before {
      background: ${(props) => props.theme.colorPalette.blue[500]};
      border: 1px solid ${(props) => props.theme.colorPalette.blue[500]};
      border-radius: 50%;
    }
    .CheckBox__input:after {
      -webkit-transform: rotate(225deg);
      -ms-transform: rotate(225deg);
      transform: rotate(225deg);
      content: '';
      border: 2px solid ${(props) => props.theme.colors.WHITE};
      font-size: 12px;
      width: 4px;
      height: 10px;
      border-right: 0;
      border-bottom: 0;
      left: 10px;
      top: 5px;
      position: absolute;
    }
    .inputCheckBox {
      left: 12px;
      top: 50px;
      z-index: 1;
      @media ${(props) => props.theme.mediaQuery.medium} {
        left: 16px;
        top: 50px;
      }
    }

    .inputCheckBox.outfits-on-bag-qty-wrapper {
      display: flex;
      padding: 8px;
      align-items: center;
      border-radius: 30px;
      border: 1px solid ${(props) => props.theme.colorPalette.green[500]};
      background: rgba(255, 255, 255, 0.9);
      width: 80px;
      top: 22px;
      left: 26px;
      margin: 0;
      position: absolute;
      @media ${(props) => props.theme.mediaQuery.medium} {
        top: 18px;
        left: 10px;
      }
      &.outfits-larger-qty {
        width: 85px;
      }
      .CheckBox__input {
        height: 16px;
        width: 16px;
        top: -1px;
      }
      .CheckBox__input:disabled {
        background-color: ${(props) => props.theme.colors.WHITE};
      }
      .labelStyle {
        display: none;
        min-height: 0;
        margin: 0;
      }
      .CheckBox__input:checked:before {
        background: ${(props) => props.theme.colorPalette.green[500]};
        border: 1px solid ${(props) => props.theme.colorPalette.green[500]};
        border-radius: 50%;
      }
      .CheckBox__input:checked:after {
        left: 7px;
        top: 3px;
        width: 3px;
        height: 9px;
      }
      .items-in-bag {
        color: ${(props) => props.theme.colorPalette.gray[900]};
        font-family: Nunito;
        font-size: 12px;
        font-weight: 700;
        position: absolute;
        right: 8px;
      }
    }
  }
  .ctl-product-customize-form-part {
    .outfits-checkbox {
      @media ${(props) => props.theme.mediaQuery.medium} {
        top: 47px;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .outfits-on-bag-multi-add-modal {
      .inputCheckBox {
        top: 40px;
      }
      &.outfits-on-bag-qty-wrapper {
        top: 58px;
      }
    }
  }
  .TCPModal__InnerContent.atb-innerContent.multi-atb-drawer-modal.outfits-on-bag-multi-add-modal {
    padding-right: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-left: 20px;
    }
    .add-to-bag-button {
      border-radius: 6px;
    }
  }
`;

export const productInfoStyles = css`
  margin-bottom: 10px;
  .product {
    margin: 0;
    width: 100%;
  }
`;
